import { cn } from '../../lib/utils';
import { transCls } from '../../const/ui';
import { getDepthPadding, getEntryIconClass } from './build-tree';
import type { EntryTreeItem } from './types';

export function EntryItem({
  item,
  depth,
  isSelected,
  onClick,
}: {
  item: EntryTreeItem;
  depth: number;
  isSelected: boolean;
  onClick: () => void;
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-between h-[34px] px-[10px] cursor-pointer rounded-[4px] shrink-0',
        getDepthPadding(depth),
        'hover:bg-[#EFF0F6]',
        isSelected && 'bg-[#EFF0F6]',
        transCls,
      )}
      onClick={onClick}
    >
      <span className="flex items-center gap-[6px] min-w-0 flex-1">
        <i
          className={
            item.entry
              ? getEntryIconClass(item.entry)
              : 'node-icon icon-bsy-form icon-new-bsy-form-25'
          }
          style={{ fontSize: 16, lineHeight: 1 }}
        />
        <span className="text-[14px] text-[#030303] truncate">
          {item.name}
        </span>
      </span>
    </div>
  );
}
